// Used to show the different post tiers: basic, premium etc
import Box from "@mui/material/Box";
import {Button, useTheme} from "@mui/material";
import Typography from "@mui/material/Typography";
import Space from "../../../../Common/Space";
import {Fragment} from "react";
import Column from "../../../../Common/Column";
import Row from "../../../../Common/Row";
import Divider from "@mui/material/Divider";
import {FloatingTag} from "./FloatingTag";

export const TierCard = ({
    tier,
    selected,
    onClick,
    sx
}) => {
    const theme = useTheme();
    const showDiscount = tier.discount > 0;

    return <Box sx={{position: "relative", ...sx}}>
        {/* Background box for when opacity < 1 */}
        <Box
            sx={{
                backgroundColor: theme.palette.grey["100"],
                height: "100%",
                width: "100%",
                position: "absolute",
                borderRadius: "5px",
                top: "0px",
            }}>
        </Box>

        {/* Actual TierCard */}
        <Box
            style={{
                border: "1px solid black",
                borderRadius: "5px",
                textAlign: "center",
                width: "250px",
                alignSelf: "end",
                backgroundColor: "white",
                opacity: tier.disabled ? "0.5" : "1",
                pointerEvents: tier.disabled ? "none" : "auto",
                position: "relative",
                cursor: "pointer",
                borderColor: theme.palette.grey["500"],
            }}
            sx={selected
                ? {boxShadow: `0 0 5px 6px ${tier.color || "#9e9e9e"}`}
                : {}
            }
            onClick={tier.disabled ? () => {} : onClick}
        >
            {/* Colored top box */}
            <Box
                sx={{
                    backgroundColor: tier.color || "white",
                    padding: "10px",
                    borderRadius: "5px 5px 0 0",
                }}
            >
                <Typography sx={{fontWeight: "bold"}}>{tier.name.toUpperCase()}</Typography>
                <Space height={"5px"}/>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    verticalAlign: "top",
                }}>
                    <Typography
                        sx={{fontSize: "50px", lineHeight: "50px"}}
                    >{tier.price}</Typography>
                    <Typography sx={{
                        fontSize: "16px",
                        lineHeight: "50px",
                        position: "relative",
                        top: "12px",
                    }}>kr.</Typography>
                </Box>
                {showDiscount && (
                    <Fragment>
                        <Space height="2px"/>
                        <Typography sx={{
                            fontStyle: "italic",
                        }}>
                            Normalpris: {tier.originalPrice} kr.</Typography>
                    </Fragment>
                )}
                <Space height={"5px"}/>
                <Column>
                    <Row sx={{justifyContent: "center", height: "45px"}}>
                        <Typography sx={{fontSize: "35px"}}>
                            {tier.boost}
                        </Typography>
                        <Typography sx={{fontSize: "40px"}}>
                            ×
                        </Typography>
                    </Row>
                    <Typography>
                        så mange visninger
                    </Typography>
                </Column>
            </Box>

            {/* Benefits */}
            {tier.features.map((feature, index) => {
                return <Box key={`benefit-${tier.name}-${feature.id}`}>

                    {index === 0 && <Divider />}
                    <Typography style={{ padding: "15px 30px" }}>
                        {feature.description}
                    </Typography>
                    <Divider />
                </Box>
            })}

            <Box sx={{
                minHeight: "100px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                <Button
                    sx={{
                        margin: "20px",
                        textTransform: "unset",
                    }}
                    color="jagtred"
                    onClick={tier.disabled ? () => {} : onClick}
                    variant={selected ? "contained" : "outlined"}
                >
                    {tier.paid ? "Købt" : `Vælg ${tier.name.toLowerCase()}`}
                </Button>
            </Box>
        </Box>

        {/* Floating tag */}
        {showDiscount && (
            <FloatingTag
                discount={tier.discount}
                bgColor={tier.color}
            />
        )}
    </Box>
}